//authActions
export const SelectTool = "SELECT_TOOL";
export const SelectToolBar = "SELECT_TOOL_BAR";
export const SelectToolDrawer = "SELECT_TOOL_DRAWER";
export const ChangeSettings = "CHANGE_TOOL_SETTINGS"
export const HideDrawer = "HIDE_DRAWER";
export const ShowDrawer = "SHOW_DRAWER";

export const UpdateState = "UPDATE_STATE";